import React, { useCallback, useContext, useEffect } from 'react';

import Button from '../../../common/Button/Button';
import { FlexDiv, SubTitle, GenericP, GenericDiv } from '../../../common/Styles';
import { InputBox } from '../../../common/FormField/formField';
import { downloadFormFields, landingImgPath, GuidLinesPopText } from '../../config';
import ActionButton from '../actionButtons/actionButtons';
import { LANDING_CONSTS } from '../../../AppConstants';
import { trackClickEvents } from '../../utils';

const GuidelinesFormDesktopModal = ({ handleSubmit, onChangeInput, status }) => {
	const onChange = useCallback((val, e)=>{
		const { value, name } = e.target;
		onChangeInput(name, value);
	}, [onChangeInput]);

	useEffect(()=>{
		trackClickEvents('download_guidelines_pop_up');
	}, []);

	return (
		<>
			<FlexDiv $direction='column' align='center' bottom_M='32' directionInMobile='column'>
				<FlexDiv $width='43%'>
					<img crossOrigin='anonymous' src={landingImgPath + 'downloadImg.png'} alt='Download Guidline' load='lazy' />
				</FlexDiv>
				<SubTitle fSize='26px' color='#000' bottom_P='8' top_M='15'>
					{GuidLinesPopText.heading[status]}
				</SubTitle>
				<GenericP test_align='center'>{GuidLinesPopText.subHeading[status]}</GenericP>
			</FlexDiv>
			{status === 'def' && <form onSubmit={handleSubmit}>
				<FlexDiv $direction='column' directionInMobile='column'>
					<InputBox handleChange={onChange} field={downloadFormFields.emailField} />
				</FlexDiv>
				<FlexDiv $direction='column' directionInMobile='column'>
					<InputBox handleChange={onChange} field={downloadFormFields.mobileField} />
				</FlexDiv>
				<Button
					btnTxt='DOWNLOAD NOW'
					btnType='Flat'
					btnName='Primary'
					btnShadow
					btnWidth='100%'
					height='44px'
					handleClick={handleSubmit}
					disabled={(!downloadFormFields.emailField.value || downloadFormFields.emailField.error) || (!downloadFormFields.mobileField.value || downloadFormFields.mobileField.error)}
				/>
			</form>}
			{status === 'downloaded' && <GenericDiv top_M='22'>
				<GenericP bottom_M='40'>To start saving your business travel budget, create your free account here & start enjoying the benefits.</GenericP>
				<ActionButton show={LANDING_CONSTS.SIGNUP} />
			</GenericDiv>}
		</>
	);
};

export default GuidelinesFormDesktopModal;
